import React from 'react'
import scss from '../images/scss.jpg'
import logo from '../images/NC_logo.png'
import jnu from '../images/jnu_logo_wb.png'
import IEEE from '../images/IEEE.jpg'
import NWU from '../images/part.png'
import { motion } from 'framer-motion'
import { useRef, useState, useEffect } from "react";
import background from '../images/compress_background.jpg'


function Home1() {
  return (
    <div className="container my-3">

        <div class="card border-0 mb-4 align-items-center text-center shadow-lg bg-primary text-primary-emphasis bg-gradient bg-opacity-10">
            <div class="row g-0">
                <div class="col-md-4 my-5">
                    <img src={logo} class="img-fluid rounded-start" alt="..." style={{maxWidth:"50%"}} />
                    <h1><strong> <span style={{color:"black"}}>NET</span><span style={{color:"orangered"}}>CRYPT</span> </strong></h1>
                </div>
                <div class="col-md-8">
                <div class="card-body">
                    <h1 className='text-center'> <strong>About <span style={{color:"black"}}>NET</span><span style={{color:"orangered"}}>CRYPT</span></strong> </h1>
                    <p class="card-text my-3" style={{textAlign:"justify"}}>The International Conference on the Network and Cryptology (NETCRYPT) with machine learning is focusing on all aspects of cryptology, network security, privacy, and cyber security, attracting cutting-edge results from world-renowned scientists in the area. The objective of NETCRYPT 2026 is to provide a platform for researchers, engineers, academicians as well as industrial professionals from all over the world to present their research results and development activities in Communications and Network Engineering. This conference provides opportunities for the delegates to exchange new ideas and application experiences face to face, to establish business or research relations and to find global partners for future collaboration. It aims to provide a forum for researchers, engineers and practitioners interested in the application of information, networks and communication to discourse on research and development, professional practice in related fields.</p>
                    
                </div>
                </div>
            </div>
        </div>


        <div class="card border-0 mb-4 align-items-center text-center shadow-lg my-5 bg-info bg-gradient bg-opacity-10 text-info-emphasis">
            <div class="row g-0">
                
                <div class="col-md-8">
                <div class="card-body">
                    <h1 className='text-center'> <strong>Conference Scope</strong> </h1>
                    <p class="card-text my-3" style={{textAlign:"justify"}}>Networks are currently witnessing a significant transformation that is resulting in new ways to address the deployment of applications and services in a digital society. Over the years, the focus of the conference has shifted from raising awareness towards sharing security event histories and discussing solutions and protection strategies. The main objective of this conference is to emphasize the recent technological developments in broadband high-speed networks, peer-to-peer networks, wireless and mobile networks which have led to new challenging problems, such as providing QoS support to the emerging multimedia applications across both wired and wireless networks. It will serve as a forum for researchers from both electronics engineering and computer science to present latest research results on QoS, Authentication,  reliability, Trust management,  security and robustness issues for both wired and wireless networks with the hope that Computer and Electronics practitioners will work together to develop networks methodologies. The conference will feature prominent invited speakers as well as papers by top researchers in the field from all over the world.</p>
                    
                </div>
                </div>

                <div class="col-md-4 my-5">
                    <img src={jnu} class="img-fluid rounded-start" alt="..." style={{maxWidth:"60%"}} />
                    
                </div>

            </div>
        </div>

        {/* partner section */}
        <h1 className="card-title text-danger my-5 text-center"> <strong>Our Partners</strong> </h1>
        <div className="partner container my-5">

            
            <div class="row row-cols-2 row-cols-md-2 row-cols-lg-2">
            <div class="col-6">
                <div class="card border-0">
                <div class="card-body">
                    <img className='card-img-top mx-auto d-block' src={IEEE} alt=""  />
                </div>
                </div>
            </div>

            <div class="col-6">
                <div class="card border-0">
                <div class="card-body">
                     <img className='card-img-top mx-auto d-block' src={NWU} alt="" />
                </div>
                </div>
            </div>
            </div>

        </div>
        
        


        

    </div>
  )
}

export default Home1